module.exports = __webpack_public_path__ + "img/pop-headline.62248985.png";